// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","root":"Status_root__32J-f","path":"Status_path__1wPnW","complete":"Status_complete__-OmoO"};